
// Initialize console manager FIRST to intercept all logs
import './utils/consoleManager';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import { clearOldApiCache } from './utils/clearApiCache';
import { apiConfig } from './lib/env';
import axios from 'axios';
import { withAuthToken } from './services/api/config';

axios.interceptors.request.use(withAuthToken);

// Import fetch interceptor for development warnings
import './lib/fetchInterceptor';

// Clear any old API cache on startup
clearOldApiCache();

// Console management is now handled automatically by importing consoleManager

console.log('🚀 Application starting with API:', apiConfig.baseUrl);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

createRoot(rootElement).render(React.createElement(App));
